import { useTenantTranslation } from "hooks/formatters";
import { useLocalDatetime } from "hooks/useLocalDateTime";
import { useCallback } from "react";
import { ActiveHeatOverride } from "src/store/api/generatedApi";
import { isTodayInTimezone } from "../isTodayInTimezone";

const REQUESTED_TIME_FORMAT = "hh:mmA";

export const useFormatOverrideRequested = () => {
  const { t } = useTenantTranslation();
  const { toLocalDatetime, localTimezone } = useLocalDatetime();
  return useCallback(
    (override: Pick<ActiveHeatOverride, "created_at" | "created_by">) => {
      const isToday = isTodayInTimezone({
        timestamp: override.created_at,
        timezone: localTimezone,
      });
      return t("overrideRequested", {
        time: toLocalDatetime(
          override.created_at,
          isToday
            ? REQUESTED_TIME_FORMAT
            : `MM/DD/YYYY ${REQUESTED_TIME_FORMAT}`
        ),
        name: override.created_by,
      });
    },
    [t, toLocalDatetime, localTimezone]
  );
};
